import '../style/grid-pRzqo50s.css'
import { defineComponent as y, reactive as x, computed as u, provide as C, openBlock as $, createElementBlock as _, normalizeClass as j, normalizeStyle as h, renderSlot as v, inject as k } from "vue";
import { useMediaQuery as S } from "@vueuse/core";
import { RESPONSIVE_MAP as b } from "./constant/breakpoints.js";
import { pxlize as w } from "x-utils";
import { useBreakpoint as L } from "./hooks/useBreakpoint.js";
import { useScreen as R } from "./hooks/useScreen.js";
const A = /* @__PURE__ */ y({
  name: "e-row",
  __name: "row",
  props: {
    align: {},
    justify: {},
    gutter: {}
  },
  setup(g) {
    const t = Object.keys(b), n = g, f = x(t.reduce((e, o) => (e[o] = S(b[o]), e), {})), p = u(() => [
      "e-row",
      {
        [`e-row-flex-${n.align}`]: n.align,
        [`e-row-flex-${n.justify}`]: n.justify
      }
    ]), c = u(() => {
      const e = n.gutter;
      if (typeof e == "object")
        for (let o = 0; o < t.length; o++) {
          const r = t[o];
          if (f[r] && e[r] !== void 0)
            return e[r];
        }
      return e;
    }), m = u(() => {
      let e = {};
      const o = c.value;
      return o && typeof o == "number" && (e = {
        marginLeft: o / -2 + "px",
        marginRight: o / -2 + "px"
      }), e;
    });
    return C("rowGutter", {
      getVal: () => c.value
    }), (e, o) => ($(), _("div", {
      class: j(p.value),
      style: h(m.value)
    }, [
      v(e.$slots, "default")
    ], 6));
  }
}), M = /* @__PURE__ */ y({
  name: "e-col",
  __name: "col",
  props: {
    span: {},
    offset: {},
    push: {},
    pull: {},
    order: {},
    sm: {},
    md: {},
    lg: {},
    xl: {}
  },
  setup(g) {
    const t = g, { span: n, order: f, offset: p, push: c, pull: m } = x(t), e = u(() => {
      let l = {};
      return ["sm", "md", "lg", "xl"].forEach((i) => {
        let s = {};
        const G = typeof t[i];
        /^\d+$/.test(t[i]) ? s.span = t[i] : G === "object" && (s = t[i] || {}), l = {
          ...l,
          [`e-col-${i}-${s.span}`]: s.span !== void 0,
          [`e-col-${i}-order-${s.order}`]: s.order || s.order === 0,
          [`e-col-${i}-offset-${s.offset}`]: s.offset || s.offset === 0,
          [`e-col-${i}-push-${s.push}`]: s.push || s.push === 0,
          [`e-col-${i}-pull-${s.pull}`]: s.pull || s.pull === 0
        };
      }), [
        "e-col",
        {
          [`e-col-${n}`]: n,
          [`e-col-order-${f}`]: f,
          [`e-col-offset-${p}`]: p,
          [`e-col-pull-${m}`]: m,
          [`e-col-push-${c}`]: c
        },
        { ...l }
      ];
    }), { getVal: o } = k("rowGutter") || {}, r = u(() => o?.()), a = u(() => {
      let l = {};
      const d = r.value;
      return d && typeof d == "number" && (l = {
        paddingLeft: d / 2 + "px",
        paddingRight: d / 2 + "px"
      }), l;
    });
    return (l, d) => ($(), _("div", {
      class: j(e.value),
      style: h(a.value)
    }, [
      v(l.$slots, "default")
    ], 6));
  }
}), N = /* @__PURE__ */ y({
  name: "e-grid",
  __name: "grid",
  props: {
    isContainer: { type: Boolean },
    gap: {},
    rowGap: {},
    columnGap: {},
    justifyItems: {},
    span: {},
    justifySelf: {}
  },
  setup(g) {
    const t = g, { breakpoint: n } = L(), f = R(), p = (e, o = 0) => {
      if (typeof e == "object") {
        const r = ["xl", "lg", "md", "sm"];
        if (e[n.value]) return e[n.value];
        for (let a = 0; a < r.length; a++)
          if (e[r[a]] && f[r[a]])
            return e[r[a]];
        return o;
      }
      return e;
    }, c = u(() => [
      {
        "e-grid-container": t.isContainer,
        [`e-grid-justify-items-${t.justifyItems}`]: t.isContainer && t.justifyItems,
        [`e-grid-justify-self-${t.justifySelf}`]: !t.isContainer && t.justifySelf,
        [`e-grid-span-${p(t.span, 24)}`]: !t.isContainer
      }
    ]), m = u(() => {
      if (!t.isContainer) return;
      const { gap: e, rowGap: o, columnGap: r } = t, a = e ? p(e) : 0, l = {
        rowGap: o ? p(o) : a,
        columnGap: r ? p(r) : a
      };
      return {
        "--row-gap": w(l.rowGap),
        "--column-gap": w(l.columnGap)
      };
    });
    return (e, o) => ($(), _("div", {
      class: j(["e-grid", c.value]),
      style: h(m.value)
    }, [
      v(e.$slots, "default")
    ], 6));
  }
});
export {
  M as Col,
  N as Grid,
  A as Row
};
//# sourceMappingURL=grid.js.map
